/**
 * Mirrors admin-dashboard/src/constants/subcategories.js — puffs and pods vary
 * by brand (the brand field covers that), so those categories have no entry.
 */
const VALUES = {
  device: ["box", "accu", "atomizer"],
  kit: ["mech", "coil"],
  accessory: ["box_protection", "ring", "drip_tube", "accu_charger", "pyrex"],
};

export const hasSubcategories = (category) => Boolean(VALUES[category]);

export const subcategoriesFor = (category) =>
  (VALUES[category] || []).map((value) => ({ value, label: value }));
